import { FileCode2, Package, Ship } from "lucide-react";
import Reveal from "./Reveal";
import { tc, tb, tbr } from "../lib/themeStyles";

const FORMATS = ["SolidWorks", "AutoCAD", "STEP", "IGES", "DXF", "DWG", "PDF"];
const PACKAGING = [
  "VCI Anti-Rust Wrapping — prevents oxidation during sea freight",
  "Custom Timber & Wooden Crating",
  "Seaworthy Export-Grade Packaging",
  "ISPM 15 Compliant Wood Packaging",
];
const LOGISTICS = [
  "Proximity to JNPT (Jawaharlal Nehru Port, Mumbai)",
  "Nhava Sheva port access",
  "Flexible Incoterms: FOB · CIF · DDP · EXW",
  "Sea freight + Air freight options",
];
const MARKERS = [
  { left: "20%", top: "38%", label: "USA" },
  { left: "47%", top: "32%", label: "EU" },
  { left: "62%", top: "55%", label: "IN" },
  { left: "78%", top: "60%", label: "AU" },
  { left: "55%", top: "55%", label: "ME" },
];

export default function SupplyChain() {
  return (
    <section id="supply-chain" className="section-shell">
      <div className="section-inner">
        <Reveal>
          <div className="label-cap mb-4" style={tc.accent}>
            04 — Global Supply Chain
          </div>
          <h2 className="section-title max-w-[820px] mb-14">
            From CAD to container — engineered for cross-border procurement.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
          <Reveal className="space-y-10">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <FileCode2 size={18} style={tc.accent} />
                <h3 className="label-cap" style={tc.muted}>
                  Engineering Interoperability
                </h3>
              </div>
              <div className="flex flex-wrap gap-2">
                {FORMATS.map((f) => (
                  <span key={f} className="pill-tag">
                    {f}
                  </span>
                ))}
              </div>
            </div>
            <div>
              <div className="flex items-center gap-3 mb-4">
                <Package size={18} style={tc.accent} />
                <h3 className="label-cap" style={tc.muted}>
                  Export Packaging
                </h3>
              </div>
              <ul className="space-y-3">
                {PACKAGING.map((p) => (
                  <li key={p} className="text-[15px] flex gap-3 leading-relaxed" style={tc.primary}>
                    <span className="mt-2.5 w-1.5 h-1.5 rounded-full shrink-0" style={tb.accentBright} />
                    {p}
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <div className="flex items-center gap-3 mb-4">
                <Ship size={18} style={tc.accent} />
                <h3 className="label-cap" style={tc.muted}>
                  Logistics
                </h3>
              </div>
              <ul className="space-y-3">
                {LOGISTICS.map((p) => (
                  <li key={p} className="text-[15px] flex gap-3 leading-relaxed" style={tc.primary}>
                    <span className="mt-2.5 w-1.5 h-1.5 rounded-full shrink-0" style={tb.accentBright} />
                    {p}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal
            delay={120}
            className="relative rounded-2xl border p-6 aspect-[16/10] overflow-hidden"
            style={{ ...tb.surface, ...tbr.default }}
          >
            <svg viewBox="0 0 1000 500" className="w-full h-full" aria-hidden="true">
              <g fill="#0a0a1a" stroke="#1e2a4a" strokeWidth="1">
                <path d="M120,140 C150,100 220,90 260,120 C300,150 280,210 240,230 C200,250 140,240 120,200 Z" />
                <path d="M300,330 C320,300 380,300 410,340 C430,380 400,430 360,430 C320,430 290,380 300,330 Z" />
                <path d="M440,120 C500,90 580,100 600,140 C620,180 580,220 530,220 C470,220 420,170 440,120 Z" />
                <path d="M530,260 C560,240 600,250 610,290 C620,330 580,360 550,350 C520,340 510,290 530,260 Z" />
                <path d="M620,160 C700,140 800,150 830,200 C860,260 800,310 720,310 C640,310 580,250 620,160 Z" />
                <path d="M770,360 C800,340 850,350 860,390 C870,420 830,440 800,430 C770,420 750,380 770,360 Z" />
              </g>
            </svg>
            {MARKERS.map((m) => (
              <div
                key={m.label}
                style={{ left: m.left, top: m.top }}
                className="absolute -translate-x-1/2 -translate-y-1/2 flex items-center gap-2"
              >
                <span className="relative flex h-2.5 w-2.5">
                  <span
                    className="absolute inset-0 rounded-full opacity-70 animate-ping"
                    style={tb.accentBright}
                  />
                  <span className="relative rounded-full w-2.5 h-2.5" style={tb.accentBright} />
                </span>
                <span className="label-cap" style={tc.primary}>
                  {m.label}
                </span>
              </div>
            ))}
            <div className="absolute bottom-4 left-6 label-cap" style={tc.muted}>
              Active export corridors — 30+ countries
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
